export const ChartDot = (props) => {
  const { cx, cy, index, data, gameOn, color } = props;
  if (index === data.length - 1) {
    return (
      <g>
        <defs>
          {/* Static Blur for when gameOn is false */}
          <filter
            id="staticBlur"
            x="-100%"
            y="-100%"
            width="300%"
            height="300%"
          >
            <feGaussianBlur in="SourceGraphic" stdDeviation="5" />
          </filter>

          {/* Pulsating Blur for when gameOn is true */}
          <filter
            id="pulsateBlur"
            x="-200%"
            y="-200%"
            width="600%"
            height="600%"
          >
            <feGaussianBlur in="SourceGraphic">
              {gameOn && (
                <animate
                  attributeName="stdDeviation"
                  from="5"
                  to="10"
                  dur="1s"
                  repeatCount="indefinite"
                  begin="0s"
                  values="5;10;5"
                  keyTimes="0;0.5;1"
                />
              )}
            </feGaussianBlur>
          </filter>
        </defs>

        {/* Outer Circle with Conditional Filter */}
        <circle
          cx={cx}
          cy={cy}
          r={7}
          fill="none"
          stroke={color}
          strokeWidth={13}
          opacity={0.5}
          filter={gameOn ? "url(#pulsateBlur)" : "url(#staticBlur)"}
        >
          {gameOn && (
            <animate
              attributeName="opacity"
              values="0.5;1;0.5"
              dur="1s"
              repeatCount="indefinite"
              keyTimes="0;0.5;1"
            />
          )}
        </circle>

        {/* Inner solid dot */}
        <circle
          cx={cx}
          cy={cy}
          r={8} // Inner dot radius
          fill={color}
          stroke={color}
        />
      </g>
    );
  }
  return null;
};
